import React from "react";
import { motion } from "framer-motion";
import { UserCheck, Sparkles } from "lucide-react";
import FormGeneralInfo from "blocks/form-general-info/form-general-info";

const GeneralInfoPage = () => {
  return (
    <div className="min-h-screen p-4 lg:p-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-7xl mx-auto"
      >
        {/* Page Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="mb-8"
        >
          <div className="flex items-center gap-3 mb-2">
            <motion.div
              initial={{ rotate: -180, scale: 0 }}
              animate={{ rotate: 0, scale: 1 }}
              transition={{ type: "spring", stiffness: 200, delay: 0.3 }}
              className="p-3 rounded-2xl bg-gradient-to-br from-purple-500/20 to-pink-500/20"
            >
              <UserCheck className="w-7 h-7 text-white" />
            </motion.div>
            <h2 className="text-3xl font-bold text-white flex items-center gap-2">
              General Information
              <Sparkles className="w-6 h-6 text-purple-400" />
            </h2>
          </div>
          <p className="text-white/60 text-lg ml-16">
            Update your contact details and communication preferences
          </p>
        </motion.div>

        {/* Form Container */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <FormGeneralInfo />
        </motion.div>

        {/* Background Gradient Orbs */}
        <motion.div
          className="fixed top-20 right-10 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl pointer-events-none"
          animate={{
            x: [0, 30, 0],
            y: [0, -30, 0],
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
        <motion.div
          className="fixed bottom-20 left-10 w-96 h-96 bg-pink-500/10 rounded-full blur-3xl pointer-events-none"
          animate={{
            x: [0, -30, 0],
            y: [0, 30, 0],
          }}
          transition={{
            duration: 25,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      </motion.div>
    </div>
  );
};

export default GeneralInfoPage;